import { catalogMat } from "../../utils/constants/signalmanConstants";

class QuickView {
  constructor() {
    if(catalogMat === 'test') {
      // Set up tray with any checkboxes already checked
      this.handleQuickViewClick = this.handleQuickViewClick.bind(this);
      this.openQuickView = this.openQuickView.bind(this);
      $(document).on(
        'click',
        '.pc-ProductCard-quickView',
        this.handleQuickViewClick
      );
      // Bind card quick view checkbox to add/remove products in tray
      $(document).on(
        'change',
        ".pc-ProductCard-quickView input[type='checkbox']",
        this.handleQuickViewClick
      );
    }
  }

  // Private: Event Handlers

  handleQuickViewClick(evt) {
    this.style_id = $(evt.target).parents('.pc-ProductCard').data('style-id');
    evt.target.checked = false;
    evt.preventDefault();
    evt.stopPropagation();
    return this.openQuickView(evt);
  }

  openQuickView(evt) {
    evt.preventDefault();
    const $form = $(evt.target).closest('form');
    const qty = $("meta[property='category-default-quote-qty']").attr(
      'content'
    );
    let url = `/products/styles/${this.style_id}/quick_view`;
    if (qty) {
      url += `?qty=${qty}`;
    }
    const productName = $(evt.target).attr('data-product-name');
    const tagInfo = this.style_id + ' - ' + productName;
    $.magnificPopup.open({
      items: {
        src: url
      },
      type: 'ajax',
      alignTop: true,
      closeBtnInside: false,
      closeMarkup: this.modalCloseButtonMarkup(),
      overflowY: 'hidden',
      mainClass: 'pc-Modal pc-QuickViewModal',
      removalDelay: 400,
      callbacks: {
        ajaxContentAdded() {
          let containerSelector;
          $('.pc-QuickViewModal.mfp-wrap').attr('data-before', productName);
          return (containerSelector =
            '.pc-QuickViewModal.mfp-wrap .mfp-container');
        }
      }
    });
    return CustomInk.Metrics.fireEvent('internal', 'quick view', tagInfo);
  }

  isQuickView() {
    return $('.pc-Style-hero').length === 0;
  }

  toggleColorCount() {
    const $bulkColorCount = $('.pc-QuickView-bulkColorCount');
    const $singlesColorCount = $('.pc-QuickView-singlesColorCount');
    if ($bulkColorCount.hasClass('is-Visible')) {
      $bulkColorCount.removeClass('is-Visible');
      return $singlesColorCount.addClass('is-Visible');
    } else {
      $singlesColorCount.removeClass('is-Visible');
      return $bulkColorCount.addClass('is-Visible');
    }
  }

  // Private: Element Factories

  modalCloseButtonMarkup() {
    return '<span class="sb-Icon--close mfp-close"></span>';
  }
}

jQuery(() => (ProductCatalog.QuickView = new QuickView()));
